<template>
  <dialog-custom
    :centerDialogVisible="visible"
    title="修改最大使用次数"
    @handleCancel="cancel"
    @handleConfirm="confirm('dataForm')"
  >
    <el-form ref="dataForm" :model="dataForm" :rules="rules" label-width="80px">
      <el-form-item label="次数" prop="maxUseCount">
        <el-input v-model="dataForm.maxUseCount" placeholder="请输入次数"/>
      </el-form-item>
    </el-form>
  </dialog-custom>
</template>

<script>
import DialogCustom from '@/components/DialogCustom'
import { modUserMaxUseCount as mod } from '@/api/user'
export default {
  components: {
    DialogCustom
  },
  data() {
    return {
      visible: false,
      loading: false,
      dataForm: {
        userId: '',
        maxUseCount: ''
      },
      rules: {
        maxUseCount: [
          { required: true, message: '请输入次数', trigger: 'blur' }
        ]
      }

    }
  },
  methods: {
    init(row) {
      if (row) this.dataForm = row
      this.visible = true
    },
    confirm(dataForm) {
      this.$refs[dataForm].validate(valid => {
        if (valid) {
          this.loading = true
          mod(this.dataForm).then(res => {
            this.cancel()
            this.$emit('refresh')
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    cancel() {
      this.visible = false
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
